<template>
  <svg :width="width" :height="height" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.61512 10.5758C5.8495 11.1393 6.40078 11.504 7.01012 11.5C7.82734 11.4969 8.49171 10.8376 8.49987 10.0205C8.50803 9.41115 8.14729 8.85684 7.58584 8.61942C7.02538 8.38098 6.37526 8.50632 5.94323 8.93528C5.51118 9.36529 5.38075 10.0133 5.61512 10.5758Z"
      :fill="color"
    />
    <path
      d="M10.6097 10.5612C10.3824 10.0002 10.5149 9.35674 10.947 8.93217C11.3781 8.50657 12.0242 8.38235 12.5827 8.61756C13.1412 8.85277 13.504 9.40155 13.5 10.0063C13.4888 10.8341 12.8151 11.499 11.9875 11.5C11.3811 11.4929 10.8369 11.1233 10.6097 10.5612Z"
      :fill="color"
    />
    <path
      d="M15.9342 8.94421C15.5073 9.37593 15.382 10.0205 15.6173 10.5795C15.8527 11.1385 16.4009 11.501 17.0082 11.5C17.4066 11.499 17.7877 11.3391 18.0679 11.0561C18.3481 10.772 18.503 10.3891 18.5 9.99098C18.4969 9.38513 18.128 8.84036 17.5666 8.61126C17.0052 8.38215 16.3612 8.51351 15.9342 8.94421Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.97038 18.1193C3.91087 18.1193 2.89653 17.6879 2.15114 16.9228C1.41141 16.1623 0.997944 15.1351 1.00001 14.0689L1.00001 6.04974C0.998977 4.98152 1.41267 3.95532 2.1525 3.19591C2.89743 2.43129 3.91103 2.00002 4.97038 2.00002L19.0296 2C20.089 2 21.1026 2.43127 21.8475 3.19593C22.5873 3.95535 23.001 4.98156 23 6.04875L23 14.0669C23.0021 15.134 22.5896 16.1602 21.8512 16.9204C21.1077 17.6847 20.0956 18.117 19.036 18.1192H11.6348L8.33574 21.2484C6.78595 22.7178 5.00006 21.9182 5.00006 19.7844V18.1193H4.97038ZM10.8371 16.1192L19.0339 16.1192C19.5506 16.1182 20.0481 15.9056 20.4171 15.5263C20.7903 15.1421 21.0011 14.6178 21 14.0689V6.04779C21.0005 5.4999 20.7892 4.97572 20.4149 4.59152C20.045 4.21175 19.5473 4 19.0296 4L4.97038 4.00002C4.45273 4.00002 3.95504 4.21178 3.58505 4.59154C3.21078 4.97572 2.99948 5.49988 3.00001 6.04877L3.00001 14.0708C2.99895 14.6183 3.21023 15.1432 3.58425 15.5278C3.95405 15.9073 4.45243 16.1193 4.97038 16.1193H7.00006V19.7588L10.8371 16.1192Z"
      :fill="color"
    />
  </svg>
</template>

<script lang="ts">
export default {
  name: 'MessageSentOutlineIcon',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#99005c',
    },
  },
};
</script>
